import React from 'react';

function Modal({ children, onClose, onReject, onAccept }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* Close button */}
        <button style={styles.closeButton} onClick={onClose}>✕</button>
        
        {/* Scrollable Content */}
        <div style={styles.scrollableContent}>
          <div style={styles.content}>
            <h2 style={styles.title}>Investment disclaimer</h2>
            
            <h3 style={styles.subtitle}>Smart contract disclaimer</h3>
            
            <p style={styles.paragraph}>
              Participation in and transactions through a Smart Contract are decisions made independently by each user. The system operates automatically on blockchain technology, with no central authority and no ability to reverse or modify transactions.
            </p>
            
            <p style={styles.paragraph}>
              Users should carefully understand the mechanisms, terms, and associated risks before making any investment decisions. Such investments are highly volatile and may result in partial or total loss of capital. Participation constitutes acceptance of these risks at your own discretion. The developers and related parties shall not be held responsible for any outcomes resulting from users' decisions.
            </p>
            
            <p style={styles.paragraph}>
              Recommendation: Invest only what you can afford to lose, and make decisions thoughtfully at every step.
            </p>
          </div>
        </div>
        
        {/* Buttons - Fixed at bottom */}
        <div style={styles.buttonContainer}>
          <button style={styles.acceptButton} onClick={onAccept || onClose}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '15px',
    // Enable scrolling on overlay
    overflowY: 'auto',
    // For older browsers
    WebkitOverflowScrolling: 'touch'
  },
  modal: {
    backgroundColor: '#1a1a2e',
    borderRadius: '16px',
    padding: '30px 25px 20px',
    width: '100%',
    maxWidth: '500px',
    maxHeight: '95vh',
    position: 'relative',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    flexDirection: 'column',
    // Center the modal vertically
    margin: 'auto',
    // For very small screens
    '@media (max-height: 600px)': {
      maxHeight: '90vh',
      padding: '20px 15px 15px'
    }
  },
  scrollableContent: {
    flex: 1,
    overflowY: 'auto',
    paddingRight: '5px',
    marginBottom: '10px',
    maxHeight: 'calc(95vh - 150px)', // Reserve space for header and buttons
    // Custom scrollbar styling
    scrollbarWidth: 'thin',
    scrollbarColor: '#6c5ce7 transparent',
    WebkitOverflowScrolling: 'touch',
  },
  closeButton: {
    position: 'sticky',
    top: 0,
    float: 'right',
    background: 'transparent',
    border: 'none',
    fontSize: '24px',
    color: '#666',
    cursor: 'pointer',
    padding: '4px 8px',
    transition: 'color 0.2s',
    zIndex: 10,
    marginTop: '-5px',
    marginRight: '-8px'
  },
  content: {
    marginBottom: '10px',
    paddingTop: '5px',
    paddingRight: '5px'
  },
  title: {
    color: '#ffffff',
    fontSize: 'clamp(18px, 4vw, 22px)',
    fontWeight: '600',
    margin: '0 0 16px 0',
    letterSpacing: '0.3px',
    paddingRight: '30px' // Make room for close button
  },
  subtitle: {
    color: '#ffffff',
    fontSize: 'clamp(14px, 2.5vw, 16px)',
    fontWeight: '500',
    margin: '0 0 10px 0',
    letterSpacing: '0.2px'
  },
  paragraph: {
    color: '#a0a0b8',
    fontSize: 'clamp(13px, 2vw, 14px)',
    lineHeight: '1.6',
    margin: '0 0 12px 0',
    fontWeight: '300'
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    marginTop: '8px',
    paddingTop: '12px',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    flexShrink: 0, // Prevent button container from shrinking
    paddingBottom: '4px'
  },
  rejectButton: {
    flex: 1,
    padding: '12px 16px',
    backgroundColor: 'transparent',
    color: '#a0a0b8',
    border: '1px solid #3a3a5a',
    borderRadius: '10px',
    fontSize: 'clamp(13px, 2vw, 15px)',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    letterSpacing: '0.3px',
    minHeight: '44px', // Better touch target
    touchAction: 'manipulation'
  },
  acceptButton: {
    flex: 1,
    padding: '12px 16px',
    backgroundColor: '#6c5ce7',
    color: '#ffffff',
    border: 'none',
    borderRadius: '10px',
    fontSize: 'clamp(13px, 2vw, 15px)',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background 0.2s',
    letterSpacing: '0.3px',
    minHeight: '44px', // Better touch target
    touchAction: 'manipulation'
  },
  // Mobile-specific styles (will be applied via media query)
  '@media (max-width: 480px)': {
    modal: {
      padding: '20px 16px 16px',
      maxWidth: '100%',
      borderRadius: '12px',
      margin: '10px'
    },
    scrollableContent: {
      maxHeight: 'calc(85vh - 130px)',
    },
    title: {
      fontSize: '18px',
      marginBottom: '12px'
    },
    paragraph: {
      fontSize: '13px',
      lineHeight: '1.5'
    },
    acceptButton: {
      padding: '14px 12px',
      fontSize: '14px',
      minHeight: '48px'
    },
    rejectButton: {
      padding: '14px 12px',
      fontSize: '14px',
      minHeight: '48px'
    }
  },
  '@media (max-height: 700px)': {
    modal: {
      padding: '18px 16px 14px',
      maxHeight: '92vh'
    },
    scrollableContent: {
      maxHeight: 'calc(92vh - 130px)',
    },
    title: {
      fontSize: '17px',
      marginBottom: '10px'
    },
    paragraph: {
      fontSize: '12px',
      marginBottom: '8px',
      lineHeight: '1.5'
    },
    acceptButton: {
      padding: '10px 14px',
      fontSize: '13px',
      minHeight: '40px'
    }
  }
};

export default Modal;